import { action, set } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { DATE_FIELD_FORMAT_OPTIONS, DateFieldFormat } from 'garaje/utils/enums';
import { localCopy } from 'tracked-toolbox';

interface SignInFieldsDateFieldComponentArgs {
  canDelete: boolean;
  deleteFieldAction: (_: unknown) => unknown;
  field: {
    name: string;
    required: boolean;
    dateFormat: DateFieldFormat | null | undefined;
    isInvalid?: boolean;
    _content?: unknown;
  };
  handleItem: unknown;
  isConditional?: boolean;
  isDisabled?: boolean;
  isRTL: boolean;
}

export default class SignInFieldsDateFieldComponent extends Component<SignInFieldsDateFieldComponentArgs> {
  @localCopy('args.canDelete', true) declare canDelete: boolean;
  @localCopy('args.isDisabled', false) declare isDisabled: boolean;

  inputId = 'input-' + guidFor(this);
  dateFormatOptions = DATE_FIELD_FORMAT_OPTIONS;

  get isDraggable(): boolean {
    return !this.args.isConditional && !this.args.isDisabled;
  }

  get selectedDateFormat(): { value: DateFieldFormat; label: string } {
    const currentFormat = this.args.field.dateFormat || DateFieldFormat.MM_DD_YYYY;
    return this.dateFormatOptions.find((option) => option.value === currentFormat) || this.dateFormatOptions[0]!;
  }

  @action
  updateDateFormat(selected: { value: DateFieldFormat; label: string }): void {
    set(this.args.field, 'dateFormat', selected.value);
  }
}
